import {createContext} from 'react';
import {accessStatus} from "../../shared/enums";

export const AppContextDefault = {
    access: accessStatus.NONE,
    modalState: {
        confirm: null,
        confirmText: null,
        confirmToolTip: null,
        deny: null,
        denyText: null,
        denyToolTip: null,
        open: false,
        title: null
    },
    npiNumber: null,
    user: null,
    provider:{
        providerName: null,
        providerType: null,
        providerPhone: null,
        providerFax: null,
    },
    showMainModal: false,
    mainModalText: ''
}
const AppContext = createContext(AppContextDefault);
export default AppContext;